let content_blocks = require('../contents');

export function init(){
    
    $('#edit_textarea_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_textarea_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);
        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));

        let textarea = block.find('.card-body .trans.tiny-container').html();

        try {

            translations = JSON.parse(block.attr('data-translations'));
            if(typeof translations[window._content_selected_language] != 'undefined'){
                
                if(typeof translations[window._content_selected_language]['textarea'] != 'undefined'){
                    textarea = translations[window._content_selected_language]['textarea'];
                }
            }

        } catch(err){}

        tinymce.get("textarea").focus();
        tinymce.get("textarea").setContent(textarea);

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

    });

    $('#edit_textarea').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        let textarea = $(this).find('[name="textarea"]').val();

        let translations = [];
        if(window._content_languages.length > 1){

            try {
                translations = JSON.parse(block.attr('data-translations'));
                if (translations.length == 0) {
                    translations = {}
                }
            } catch(err){
                translations = [];
            }
            // preparo traducciones que no existan
            
            for(let _language of window._content_languages){
                if(typeof translations[_language] == 'undefined'){
                    translations[_language] = { 'value': ''};
                }
            }
            
            // guardo tranduccion actual 
            
            translations[window._content_selected_language]['value'] = textarea;
            
            // si es idioma base
            
            if(window._content_selected_language == window._locale){
                
                block.attr('data-value', textarea);

                // actualizamos traducciones vacias

                for(let _language of window._content_languages){
                    if(_language != window._locale){
                        if(translations[_language]['value'] == ''){
                            translations[_language]['value'] = textarea;
                        }
                    }
                }

            }

        } else {
            block.attr('data-value', textarea);
        }

        block.attr('data-translations', JSON.stringify(translations));
        block.find('.card-body .trans.tiny-container').html(textarea);
        init_textarea_block(block.attr('id'));
        
        content_blocks.change_visible_button_blocks(block);

        let modal = $(this).closest('.modal');
        modal.modal('hide');

    });

    $('.block[data-type="textarea"]').each(function(){
        init_textarea_block($(this).attr('id'));
        content_blocks.create_visible_button_blocks($(this));
    });
}

export function init_textarea_block(block_id) {

    let block = $('#content_blocks #' + block_id);
    let card_body = block.find('.card-body');
    let card_empty_body = block.find('.card-empty-body');
    if (card_body.find('.tiny-container').children().length <= 0) {
        card_empty_body.removeClass('d-none');
        card_empty_body.addClass(['d-flex', 'justify-content-center']);
    } else {
        card_empty_body.addClass('d-none');
        card_empty_body.removeClass(['d-flex', 'justify-content-center']);
    }
}